// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iPqM6","largestCol":"styles_largestCol__1-O5Y","smallestCol":"styles_smallestCol__1p6CH"};